import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {DurationConverter} from '../utils/duration-converter';

@Pipe({
  name: 'timeFromNowText',
})

export class TimeFromNowTextPipe implements PipeTransform {

  constructor(private translateService: TranslateService) {
  }

  transform(datetime: number): string {
    return DurationConverter.secondsToRoundedDuration(datetime, this.translateService);
  }
}
